export const ARROW_MARKER_ICON_SIZE = 28;
export const ARROW_MARKER_ANCHOR = ARROW_MARKER_ICON_SIZE / 2;
